/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { AnalyticsService } from './@core/utils/analytics.service';
import { UserProfileService } from './@core/utils/user-profile.service';
@Component({
  selector: 'ngx-app',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit{
  constructor(private analytics: AnalyticsService,
    private http: HttpClient) {}

  ngOnInit(): void {
    this.analytics.trackPageViews();
  }
}
